import { useState } from "react";

export default function QuizeOption({ quiz, number, handleOption }) {
  const { question, options } = quiz;
  const [isCheck, setIsCheck] = useState();
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  return (
    <div className="quiz">
      <h4 className="question">
        Quiz {number} - {question}
      </h4>
      <form className="quizOptions" onChange={handleSubmit}>
        {options.map((option, i) => (
          <label key={i}>
            <input
              name="quiz"
              type="checkbox"
              value={option.id}
              checked={option.isCorrect}
              onChange={(event) => handleOption(i, event)}
            />
            {option.option}
          </label>
        ))}
      </form>
    </div>
  );
}
